<template>
  <span/>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
  name: 'GameMixin',
  computed: {
    ...mapGetters([
      'user',
      'participation',
      'canAddParticipation',
      'reason',
      'prizes',
    ]),
    cssProps() {
      return {
        '--game-desktop-bg-color': this.game.desktop_bg_color,
        '--game-bg-color': this.game.bg_color,
        '--game-bg-text-color': this.game.bg_text_color,
        '--game-accent-color': this.game.accent_color,
        '--game-accent-color-rgb': this.convertToRGB(this.game.accent_color),
        '--game-text-color': this.game.text_color,
      }
    },
    hasCurrentParticipation() {
      return this.participation && this.participation._id;
    },
    hasAcceptedGame() {
      if (!this.user || !this.user._id) {
        return false;
      }
      return this.game.accepted_terms;
    },
    haveClaims() {
      return this.hasCurrentParticipation
        && this.participation.claims?.length > 0;
    },
  },
  watch: {
    authenticated(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getGame();
      }
    },
  },
  data() {
    return {
      loadedPage: false,
      isDevelopment: process.env.NODE_ENV !== 'production',

      acceptMerchandise: true,
      acceptTerms: false,
      tocModal: false,
      tiebreakAnswer: '',
      surveyAnswers: [],

      currentUnix: (new moment).unix(),
      randomIndex: 0,
      prize: null,
      spinMessage: '',
      spinMessageModal: false,
      addressForm: [],
      addressData: {},
      claimsModal: false,
    };
  },
  methods: {
    attach(obj) {
      obj.entityId = this.gameId;
      obj.entityType = this.gameType;
      return obj;
    },
    async getGame() {
      try {
        const success = await this.$store.dispatch('getGame', this.attach({ authenticated: this.authenticated }))
        if (!success) {
          if (!this.game || !this.game._id) {
            this.setAlert(this.reason);
            this.$router.push({ name: 'UserStart' });
            return false;
          }
          this.gotoError();
          return false;
        }
  
        this.setPageTitle(this.game.name, this.game.company.name);
        this.acceptMerchandise = this.game.terms_merchandise_default;
        this.setRandomFact();
        this.pushDataLayer({
          parentCompany: this.game.company.parentCompany,
          company: this.game.company,
          game: this.game,
          action: 'Enter',
        });
  
        this.setStep();
        return true;
      } catch (error) {
        console.error('Error fetching game:', error);
        this.setAlert('Failed to load game data.');
        return false;
      }
    },
    participate() {
      this.$store.dispatch('participate', this.attach({
        tiebreakAnswer: this.tiebreakAnswer,
        acceptTerms: this.acceptTerms || this.hasAcceptedGame,
        acceptMerchandise: this.acceptMerchandise,
        thirdPartyCrmName: this.thirdPartyCrmName,
      }))
      .then(() => {
        this.setStep();
      });
    },
    setSurvey() {
      this.$store.dispatch('answerGameSurvey', this.attach({ answers: this.surveyAnswers }))
      .then((success) => {
        if (!success) {
          this.setAlert(this.reason);
          return;
        }

        this.setStep();
      });
    },
    setAddress() {
      this.$store.dispatch('answerGameAddress', this.attach({ answers: this.addressData }))
      .then((success) => {
        if (!success) {
          this.setAlert(this.reason);
          return;
        }

        this.setStep();
      });
    },
    getRandomInt(max) {
      return Math.floor(Math.random() * max);
    },
    setRandomFact() {
      if (this.game.hunt_funfacts && this.game.hunt_funfacts.length) {
        this.randomIndex = this.getRandomInt(this.game.hunt_funfacts.length);
      }
    },
    acceptGameTerms() {
      this.tocModal = false;
      this.acceptTerms = true;
    },
    setAddressData() {
      const game = this.game;
      this.addressForm = [
        {
          label: `${this.transl.Offer.firstname} ${this.transl.Offer.lastname}`,
          required: true,
          model: 'nameAtAddress',
          id: 'name',
        },
        {
          label: this.transl.Offer.street,
          required: true,
          model: 'address',
          id: 'address',
        },
        {
          label: this.transl.Offer.postalcode,
          required: true,
          model: 'postalCode',
          id: 'postal-code',
        },
        {
          label: this.transl.Offer.city,
          required: true,
          model: 'city',
          id: 'address-level2',
        },
      ];
      if (game.address_country) {
        this.addressForm.push({
          label: 'Ange ditt land',
          required: true,
          model: 'country',
          id: 'country',
          // options: [{ text: 'Sverige', _id: 'SE' }],
        });
      }
      if (game.address_state) {
        this.addressForm.push({
          label: 'Ange ditt landskap',
          required: true,
          model: 'state',
          id: 'state',
        });
      }

      let addressData = {
        nameAtAddress: `${this.user.name} ${this.user.last_name}`,
        address: this.user.adress,
        postalCode: this.user.postal_code,
        city: this.user.city,
        state: this.user.state,
        country: this.user.country,
      };

      this.addressData = addressData;
    },
    ctaDoneRedirect() {
      if (this.game.cta_done_url) {
        this.openUrl(this.game.cta_done_url, true);
      } else {
        this.$router.push({ name: 'HomeCompany', params: { companyId: this.getId(this.game.company) } });
      }
    },
    convertToRGB(color) {
      const tempElement = document.createElement('div');
      tempElement.style.color = color;
      document.body.appendChild(tempElement);
  
      const computedColor = getComputedStyle(tempElement).color;
      document.body.removeChild(tempElement);
  
      const rgbMatch = computedColor.match(/\d+, \d+, \d+/);
      return rgbMatch ? rgbMatch[0] : '0, 0, 0';
    },
  }
};
</script>
